import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../../theme';

// Reused by ConfirmOrderPage.jsx and shipmentSummaries.jsx's ShipmentSummariesCol —
// no single owning component.
export const useShipmentDetailSharedStyles = createStyles(() => ({
  leftColumn: {
    width: 370,
  },
}));

export const blindedBlock = (fontSize = ThemeFont.FONT_SIZE_SM_PLUS) => ({
  fontWeight: 500,
  fontStyle: 'italic',
  color: ThemeColors.COLOR_GREY_BLUISH,
  fontSize,
  display: 'flex',
  alignItems: 'center',
});
